"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharmAbilityHandler = exports.CharmActorAbilityFactory = exports.CharmAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const EffectType_1 = require("../../core/effects/EffectType");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class CharmAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Charm;
        this.__typeName = "Charm";
    }
}
exports.CharmAbilityArgs = CharmAbilityArgs;
let CharmActorAbilityFactory = class CharmActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Charm", "OneEnemies", 4);
    }
};
CharmActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Charm")
], CharmActorAbilityFactory);
exports.CharmActorAbilityFactory = CharmActorAbilityFactory;
let CharmAbilityHandler = class CharmAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        if (container.hasEffectOfType(targetId, EffectType_1.EffectType.Charmed)) {
            return;
        }
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                container.applyDebuff({
                    sequence: sequence.pushSequence("sequential"),
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_1.CharmedEffectArgs(),
                    onAppliedOrResisted: (sequence, _, applied) => sequence.push(new core_2.InstantVfxStepArgs(applied ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "head")
                        : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "MagicBubble"))
                });
            }
        });
    }
};
CharmAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Charm)
], CharmAbilityHandler);
exports.CharmAbilityHandler = CharmAbilityHandler;
